import { Box } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SchedulerBlock from '../SchedulerBlock/SchedulerBlock';

const freshDay = new Date();

freshDay.setHours(0, 0, 0, 0);

function SchedulerDay({
  session,
  availableStartDate,
  availableHours,
  dataTestId,
  className,
}) {
  const classes = classnames('SchedulerDay', className);
  const startDateTime = new Date(availableStartDate);

  const getStart = () => startDateTime.toString();

  const getEndTime = () => {
    startDateTime.setHours(startDateTime.getHours() + availableHours);

    return startDateTime.toString();
  };

  return (
    <Box dataTestId={dataTestId} className={classes}>
      {session ? (
        <SchedulerBlock
          details={{
            firstname: session.firstname,
            lastname: session.lastname,
            username: session.username,
            startDate: session.startDate,
            endDate: session.endDate,
            requestId: session.requestId,
          }}
          startTime={session.startDate}
          endTime={session.endDate}
        />
      ) : (
        <SchedulerBlock startTime={getStart()} endTime={getEndTime()} />
      )}
    </Box>
  );
}

SchedulerDay.propTypes = {
  session: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    username: PropTypes.string,
    requestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  availableStartDate: PropTypes.instanceOf(Date),
  availableHours: PropTypes.number,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
};

SchedulerDay.defaultProps = {
  session: null,
  availableStartDate: freshDay,
  availableHours: 12,
  dataTestId: null,
  className: null,
};

export default SchedulerDay;
